/* eslint-disable max-len */

import React, { memo } from 'react'

import { useCaseOptions } from 'Pods/ThreeDStudio/Components/MainPanel/Components/LeftSide/Components/ModelSettings/Components/UseCaseSelector/useCaseOptions'
import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function CollapsedUseCaseRow() {
  const selectedUseCase = useThreeDStudioStore(state => state.modelSettings.selectedUseCase)

  if (!selectedUseCase) {
    return null
  }

  const option = useCaseOptions.find(item => item.id === selectedUseCase)

  if (!option) {
    return null
  }

  return (
    <ClosedButtonSettings
      label="Use case"
      isActive
      buttonLabel={option.title}
    />
  )
}

export default memo(CollapsedUseCaseRow)
